<template>
    <b-form-select v-bind="$attrs" v-on="$listeners" :options="options" class="per-page" />
</template>

<script>
const DEFAULT_OPTION = 10

export default {
    name: 'PaginationPerPage',
    props: {
        options: {
            type: Array,
            required: false,
            default: () => [DEFAULT_OPTION, 25, 50, 100],
        },
    },
    created() {
        try {
            this.validateSelectedOption()
        } catch (message) {
            this.invalidOptionSelected(message)
        }
    },
    methods: {
        emitValue(value) {
            this.$emit('input', value)
        },
        validateSelectedOption() {
            if (!this.isSelectedOptionAvailable())
                throw new Error(
                    `An invalid option was selected for ${this.$options.name}. Choose an available option, otherwise the default option (${DEFAULT_OPTION}) will be selected.`
                )
        },
        isSelectedOptionAvailable() {
            return this.options.includes(this.$attrs.value)
        },
        invalidOptionSelected(message) {
            this.emitValue(DEFAULT_OPTION)
            console.warn(message)
        },
    },
}
</script>

<style lang="scss" scoped>
.per-page {
    width: unset;
}
</style>
